import React from "react";
import * as Styled from "./ErrorSearchContainer.styles";

// gordon-0915-video-block-media-pane-pixabay-embed-first-record-tier item 1:
// a real provider failure (bad/expired key, rate limit, malformed response)
// used to render byte-identical to a genuine zero-result search
// (EmptySearchContainer, "No results found"). This is the DISTINCT error
// state the note asked for, with a Retry action, so a transient upstream
// failure never looks like "this search has no results".
function ErrorSearchContainer({ onRetry }) {
  return (
    <Styled.Container role="alert">
      <Styled.ContainerChild>
        <Styled.TextContainer>
          <Styled.TextParagraph>Could not load results.</Styled.TextParagraph>
        </Styled.TextContainer>
        <Styled.RetryButton type="button" title="Retry" onClick={onRetry}>
          Retry
        </Styled.RetryButton>
      </Styled.ContainerChild>
    </Styled.Container>
  );
}

export default ErrorSearchContainer;
